import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const BuyDexRockets = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>BuyDexRockets - Buy Dexscreener Rockets 🚀 | #1 Provider | Dexreaction</title>
        <meta name="description" content="BuyDexRockets - The #1 place to buy Dexscreener rockets! Get authentic rocket 🚀 reactions from $0.05. Fastest delivery, 20% bonus free. BuyDexRockets for your token success!" />
        <meta name="keywords" content="buydexrockets, buy dex rockets, buydexscreener rockets, buy dexscreener rockets, dexscreener rockets, buy dexscreener reaction, buy dexscreener fire, buy dexscreener poop, dexreactions, rocket dexscreener, dexscreener rocket emoji" />
        <link rel="canonical" href="https://dexreaction.com/buydexrockets" />
        <meta property="og:title" content="BuyDexRockets - #1 Dexscreener Rockets Provider | Dexreaction" />
        <meta property="og:description" content="BuyDexRockets - Buy rocket reactions from $0.05! Fastest delivery, 20% bonus free!" />
        <meta property="og:image" content="https://dexreaction.com/og-image.png" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://dexreaction.com/buydexrockets" />
        <link rel="sitemap" type="application/xml" href="/sitemap.xml" />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-b from-slate-900 via-orange-900/20 to-slate-900">
        {/* Header */}
        <nav className="fixed top-0 w-full bg-slate-900/80 backdrop-blur-md border-b border-orange-500/20 z-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-16">
              <div className="flex items-center cursor-pointer" onClick={() => navigate('/')}>
                <img src="/logo-light.png" alt="Dexreaction" className="h-8" />
              </div>
              <button onClick={() => navigate('/')} className="bg-orange-600 hover:bg-orange-700 text-white px-6 py-2 rounded-lg font-semibold transition-colors">
                BuyDexRockets Now
              </button>
            </div>
          </div>
        </nav>

        {/* Hero Section */}
        <section className="pt-32 pb-20 px-4">
          <div className="max-w-6xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 bg-orange-500/20 text-orange-300 px-6 py-3 rounded-full font-semibold mb-6">
              🚀 BuyDexRockets - #1 Rocket Provider
            </div>
            <h1 className="text-5xl md:text-7xl font-bold mb-6">
              <span className="bg-gradient-to-r from-orange-400 via-yellow-400 to-red-400 bg-clip-text text-transparent">
                BuyDexRockets
              </span>
            </h1>
            <div className="text-8xl mb-6 animate-bounce">🚀</div>
            <p className="text-xl md:text-2xl text-gray-300 mb-4 max-w-3xl mx-auto">
              The Ultimate Destination to Buy Dexscreener Rockets
            </p>
            <p className="text-lg text-gray-400 mb-8 max-w-2xl mx-auto">
              BuyDexRockets is your go-to service for authentic Dexscreener rocket reactions. Boost your token&apos;s visibility, show bullish momentum, and attract investors!
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => navigate('/')}
                className="bg-gradient-to-r from-orange-600 to-red-600 hover:from-orange-700 hover:to-red-700 text-white px-10 py-4 rounded-lg font-bold text-xl transition-all transform hover:scale-105 inline-flex items-center gap-2"
              >
                🚀 BuyDexRockets Now
              </button>
              <button
                onClick={() => window.open('https://t.me/dexreactionrobot', '_blank')}
                className="bg-slate-800 hover:bg-slate-700 text-white px-10 py-4 rounded-lg font-bold text-xl transition-all border border-orange-500/30"
              >
                Telegram Bot
              </button>
            </div>
          </div>
        </section>

        {/* Why BuyDexRockets */}
        <section className="py-16 px-4 bg-slate-900/50">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              Why BuyDexRockets?
            </h2>
            <div className="grid md:grid-cols-3 gap-8">
              {[
                { icon: '🏆', title: '#1 Provider', desc: 'BuyDexRockets is the most trusted source for Dexscreener rocket reactions. Thousands of satisfied customers!' },
                { icon: '💰', title: 'Best Prices', desc: 'Get rockets at just $0.05 each + 20% bonus free. BuyDexRockets offers unbeatable value!' },
                { icon: '⚡', title: 'Instant Delivery', desc: 'When you BuyDexRockets from us, delivery starts immediately. 500 rockets per 10 minutes!' }
              ].map((item, idx) => (
                <div key={idx} className="bg-gradient-to-br from-orange-900/30 to-red-900/30 border border-orange-500/20 rounded-xl p-6 text-center hover:border-orange-500/50 transition-all">
                  <div className="text-5xl mb-4">{item.icon}</div>
                  <h3 className="text-xl font-bold mb-3">{item.title}</h3>
                  <p className="text-gray-400">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* BuyDexRockets Pricing */}
        <section className="py-16 px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">
              BuyDexRockets Packages
            </h2>
            <p className="text-center text-gray-400 mb-12 text-lg">
              $0.05 per rocket + 20% Bonus FREE when you BuyDexRockets
            </p>
            <div className="grid md:grid-cols-4 gap-6">
              {[
                { qty: 500, price: 25, total: 600 },
                { qty: 1000, price: 50, total: 1200, popular: true },
                { qty: 1500, price: 75, total: 1800 },
                { qty: 2000, price: 100, total: 2400 }
              ].map((pkg) => (
                <div key={pkg.qty} className={`relative bg-gradient-to-br from-orange-900/30 to-red-900/30 border-2 ${pkg.popular ? 'border-orange-500' : 'border-orange-500/30'} rounded-xl p-6 hover:border-orange-500 transition-all`}>
                  {pkg.popular && (
                    <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                      <span className="bg-gradient-to-r from-orange-600 to-red-600 text-white px-4 py-1 rounded-full text-sm font-bold">Best Seller</span>
                    </div>
                  )}
                  <div className="text-center">
                    <div className="text-4xl mb-2">🚀</div>
                    <div className="text-3xl font-bold mb-2">{pkg.qty}</div>
                    <div className="text-gray-400 mb-4">Rockets</div>
                    <div className="text-4xl font-bold text-orange-400 mb-2">${pkg.price}</div>
                    <div className="bg-green-500/20 rounded-lg p-2 mb-4">
                      <span className="text-green-400 font-semibold">Get {pkg.total} total</span>
                    </div>
                    <button
                      onClick={() => navigate('/')}
                      className="w-full bg-orange-600 hover:bg-orange-700 text-white py-3 rounded-lg font-semibold transition-colors"
                    >
                      BuyDexRockets
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* How to BuyDexRockets */}
        <section className="py-16 px-4 bg-slate-900/50">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              How to BuyDexRockets
            </h2>
            <div className="space-y-6">
              {[
                { step: 1, title: 'Choose Package', desc: 'Select how many rockets you want to buy. All BuyDexRockets packages include 20% bonus!' },
                { step: 2, title: 'Enter Token Link', desc: 'Provide your DexScreener token URL where rockets will be delivered.' },
                { step: 3, title: 'Pay with SOL', desc: 'Complete secure payment using Solana. Wallet connection or manual transfer.' },
                { step: 4, title: 'Rockets Delivered!', desc: 'When you BuyDexRockets, delivery starts immediately at 500/10min.' }
              ].map((item) => (
                <div key={item.step} className="flex gap-4 bg-slate-800/50 border border-orange-500/20 rounded-xl p-6">
                  <div className="flex-shrink-0 w-12 h-12 bg-orange-600 rounded-full flex items-center justify-center text-xl font-bold">
                    {item.step}
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2">{item.title}</h3>
                    <p className="text-gray-400">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* BuyDexRockets Benefits */}
        <section className="py-16 px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              BuyDexRockets Benefits
            </h2>
            <div className="grid md:grid-cols-2 gap-6">
              {[
                { icon: '📈', title: 'Boost Rankings', desc: 'BuyDexRockets to improve your token\'s trending position on DexScreener' },
                { icon: '🎯', title: 'Bullish Signal', desc: 'Rockets show strong upward momentum - attract more investors' },
                { icon: '🔒', title: 'Safe & Secure', desc: 'Natural delivery patterns when you BuyDexRockets - no risk to your token' },
                { icon: '🤖', title: 'Telegram Bot', desc: 'BuyDexRockets via our Telegram bot for even faster ordering' },
                { icon: '24/7', title: 'Always Available', desc: 'BuyDexRockets anytime - our automated service runs 24/7' },
                { icon: '💎', title: 'Premium Quality', desc: 'All rockets delivered through authentic accounts' }
              ].map((item, idx) => (
                <div key={idx} className="flex gap-4 bg-slate-800/50 border border-orange-500/20 rounded-xl p-6">
                  <div className="text-3xl flex-shrink-0">{item.icon}</div>
                  <div>
                    <h3 className="text-xl font-bold mb-2">{item.title}</h3>
                    <p className="text-gray-400">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-16 px-4 bg-slate-900/50">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              BuyDexRockets FAQ
            </h2>
            <div className="space-y-4">
              {[
                { q: 'What is BuyDexRockets?', a: 'BuyDexRockets is a premium service to purchase authentic Dexscreener rocket 🚀 reactions for your token. Rockets are the most popular bullish reaction!' },
                { q: 'Why should I BuyDexRockets?', a: 'Rockets signal bullish momentum and attract investors. High rocket counts improve your token\'s visibility and trending position on DexScreener.' },
                { q: 'How fast do I get rockets after I BuyDexRockets?', a: 'Delivery starts immediately! We deliver 500 rockets every 10 minutes for natural-looking growth.' },
                { q: 'Is BuyDexRockets safe?', a: 'Absolutely! We use authentic accounts and natural delivery patterns. Your token will not be flagged or penalized.' }
              ].map((faq, idx) => (
                <div key={idx} className="bg-slate-800/50 border border-orange-500/20 rounded-xl p-6">
                  <h3 className="text-lg font-bold mb-2 text-orange-400">{faq.q}</h3>
                  <p className="text-gray-400">{faq.a}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-20 px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Ready to BuyDexRockets? 🚀
            </h2>
            <p className="text-xl text-gray-300 mb-8">
              Join thousands who BuyDexRockets for their token success
            </p>
            <button
              onClick={() => navigate('/')}
              className="bg-gradient-to-r from-orange-600 to-red-600 hover:from-orange-700 hover:to-red-700 text-white px-12 py-4 rounded-lg font-bold text-xl transition-all transform hover:scale-105"
            >
              🚀 BuyDexRockets Now
            </button>
          </div>
        </section>

        {/* Footer */}
        <footer className="bg-slate-900 border-t border-orange-500/20 py-8 px-4">
          <div className="max-w-6xl mx-auto text-center text-gray-400">
            <p>&copy; 2025 Dexreaction - BuyDexRockets. All rights reserved.</p>
            <div className="mt-4 space-x-4">
              <button onClick={() => navigate('/terms')} className="hover:text-orange-400 transition-colors">Terms</button>
              <button onClick={() => navigate('/privacy')} className="hover:text-orange-400 transition-colors">Privacy</button>
              <button onClick={() => navigate('/')} className="hover:text-orange-400 transition-colors">Contact</button>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default BuyDexRockets;
